import {DEFAULT_FILE_NAME} from '../settings/constants';
import {download} from '../../../lib/utility/helpers';

/**
 * Provides a cross-browser compatible way to download images to the user's machine (without needing an explicit server call).
 */
export class ClientDownloader {
  /**
     * Constructor.
     * @param scanner - A ViewportScanner instance.
     */
  constructor (scanner) {
    Object.defineProperties(this, {
      _scanner: {value: scanner}
    });
    Object.freeze(this);
  }

  /**
     * Downloads a tile to the user's machine.
     */
  async download (viewport, rectangle, zoom, filename = DEFAULT_FILE_NAME) {
    // This technique makes use of the <a> tag's download attribute (https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes)
    // That the download attribute only works for same-origin URLs. Since ImageServers can be on different domains than the web viewer
    // we have to request the info separately and feed it into a blob first. Once we've done this, we create a hyperlink, set the source,
    // and trigger the click event to start the download.

    const {blob, uri} = await this._scanner.capture(viewport, rectangle, zoom);

    download({uri, blob, filename});

    // Don't leave hanging references to generated images.
    setTimeout(() => {
      this._scanner.cleanup();
    }, 2000);
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/capturing/ClientDownloader.js